const LOGIN_PATH = '/auth/login';

export const sanitizeRedirectTarget = (target?: string | null): string | null => {
  if (!target) return null;

  const normalized = target.replace(/\\/g, '/');
  if (!normalized.startsWith('/') || normalized.startsWith('//')) return null;

  try {
    const url = new URL(normalized, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    if (url.pathname === LOGIN_PATH) return null;

    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};

export const buildLoginRedirectUrl = (target?: string | null): string => {
  const safe = sanitizeRedirectTarget(target);

  return safe ? `${LOGIN_PATH}?redirect=${encodeURIComponent(safe)}` : LOGIN_PATH;
};
